import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import './index.css';

// Cloudflare Web Analytics beacon (Brief 290) — PUBLIC per-site token for
// app.relaystation.ai (ships in the page, not a secret). Injected at boot; gated on
// the token so an unconfigured value emits nothing. No cookies, no consent banner.
// app.relaystation.ai Cloudflare Web Analytics (public token).
const CLOUDFLARE_ANALYTICS_TOKEN = 'b8dd360fd2b94e2fa0357f6211d8da7a';
if (CLOUDFLARE_ANALYTICS_TOKEN) {
  const beacon = document.createElement('script');
  beacon.defer = true;
  beacon.src = 'https://static.cloudflareinsights.com/beacon.min.js';
  beacon.setAttribute('data-cf-beacon', JSON.stringify({ token: CLOUDFLARE_ANALYTICS_TOKEN }));
  document.head.appendChild(beacon);
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
